<template>
  <v-app-bar absolute color="rgba(0, 0, 0, 0.85)" height="86">
    <v-container>
      <v-row>
        <v-btn
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          min-height="48"
          text
          color="grey"
          active-class="activeButton"
        >
          <v-icon left size="20" v-text="item.icon" />
          <span v-text="item.text" />
        </v-btn>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: 'HomeAppBar',
  data: () => ({
    items: [
      {
        icon: 'mdi-home',
        text: 'home',
        to: '/'
      },
      {
        icon: 'mdi-account',
        text: 'Login',
        to: '/login'
      }
    ]
  })
}
</script>
<style scoped>
.activeButton {
  color: white !important;
}
.v-btn--active:hover::before,
.theme--dark.v-btn--active::before {
  opacity: 0.1 !important;
}
</style>
